import DocumentStore from 'notebook/documents/DocumentStore';
import {useStatusBarSaveState} from 'notebook/store/useStatusBarSaveState';
import useWarnOnNavigate from 'ui-library/hooks/useWarnOnNavigate';

interface UseDocumentSaveState {
  isLatest: boolean;
  latestVersionId?: number;
  isSaving: boolean;
}

export default function useDocumentSaveState(documentId: string): UseDocumentSaveState {
  const inStore = DocumentStore.inStore(documentId);
  const isUnsaved = inStore ? DocumentStore.hasUnsavedChanges(documentId) : false;
  // Editor state is only available if the document is in the store. Throws error otherwise.
  const editorState = inStore && DocumentStore.getEditorState(documentId);

  const isLatest = editorState ? editorState.isLatest : false;
  const latestVersionId = editorState ? editorState.metadata.latestVersionId : undefined;
  const isSaving = (editorState && editorState?.saving) || isUnsaved;

  useWarnOnNavigate(Boolean(isSaving), 'Leave without saving?');
  useStatusBarSaveState({...editorState, saving: isSaving});

  return {
    isLatest,
    latestVersionId,
    isSaving,
  };
}
